export default "__VITE_ASSET__B_L$3sdP__"